import { OrgAdminConstants } from '../../../_constants';

const initialState = { makeTeamLeaderLoading: true, data: '', error: false };

export function makeTeamLeaderReducer(state = initialState, action) {

    switch (action.type) {
        case OrgAdminConstants.REQUEST_MAKE_TEAM_LEADER:
            return {
                makeTeamLeaderLoading: true,
                data: '',
                error: false
            };
        case OrgAdminConstants.RECEIVE_MAKE_TEAM_LEADER:
            return {
                makeTeamLeaderLoading: false,
                data: action.makeTeamLeader,
                error: false
            };
        case OrgAdminConstants.MAKE_TEAM_LEADER_ERROR:
            return {
                makeTeamLeaderLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/OrgAdmin/ManageTeam/makeTeamLeader.reducer.js